// import

import React from 'react';

import type {HomeMainNode, PostNode} from 'libs/model';

import {HomeFeatures} from './HomeFeatures';
import {HomeNotify} from './HomeNotify';
import {HomePosts} from './HomePosts';
import {HomeSeo} from './HomeSeo';
import {HomeSplash} from './HomeSplash';

// types

type Props = {
  main: HomeMainNode;
  posts: PostNode[];
};

// component

export function HomePage(props: Props) {
  const {main, posts} = props;
  const {meta} = main;

  return (
    <div>
      <HomeSeo main={main} posts={posts} />

      <HomeSplash {...meta.splashRegion} />
      <HomeFeatures {...meta.featuresRegion} />
      <HomeNotify {...meta.notifyRegion} />
      <HomePosts posts={posts} {...meta.postsRegion} />
    </div>
  );
}
